<div class="flex flex-col">
  <mat-label class="flex flex-row items-center gap-2" [ngClass]="labelClass">
    {{ label | translate }}
    <span *ngIf="required">*</span>
    <app-icon
      *ngIf="infoTooltip"
      class="cursor-pointer"
      [matTooltip]="infoTooltip | translate"
      iconName="info"
      size="sm"
      fill="#1f5792"
      matTooltipPosition="above"></app-icon>
  </mat-label>
  <quill-editor
    class="h-full rounded"
    [ngClass]="{'opacity-90 pointer-events-none': isDisabled}"
    [modules]="editorOptions"
    [ngModel]="value"
    [placeholder]="placeholder | translate"
    [disabled]="isDisabled"
    (ngModelChange)="onContentChange($event)"
    (onContentChanged)="onEditorChange()"
    (onEditorCreated)="onEditorCreated($event)"></quill-editor>
</div>
